/**
 * Kome je poruka išla i kojim kanalom — kako to piše na ekranu „Sa terena".
 *
 * Analiza 2.0 (T10), 14.10.2026: sve što nije bilo „kupac-najava" ili „proba"
 * pisalo je „Vozaču" (i podsetnik poslovođi za prijem), a mejl je pisao
 * „Viber". Čovek koji traži zašto poslovođa nije dobio poruku gledao je u
 * pogrešan red.
 */
export function komeJe(purpose: string): string {
  if (purpose === 'kupac-najava') return 'Kupcu';
  if (purpose === 'proba') return 'Proba';
  if (purpose.startsWith('vozac')) return 'Vozaču';
  if (purpose.startsWith('poslovodja') || purpose === 'prenos-012') return 'Objektu';
  // Alarm za prodatu robu sa naloga rezervacije (008): poslovođi i šefu magacina.
  if (purpose === 'rezervacija-kupca') return 'Rezervacija (objekat i magacin)';
  return purpose;
}

export function kanal(channel: string): string {
  if (channel === 'Sms') return 'SMS';
  if (channel === 'Email') return 'mejl';
  return 'Viber';
}

/** Poruka koja nije prošla, a niko je još nije sklonio — samo takva traži pažnju. */
export function trazPaznju(m: { status: string; acknowledgedAt: string | null }): boolean {
  return (m.status === 'Rejected' || m.status === 'Failed') && m.acknowledgedAt === null;
}
